/**
 * /studies/$id — a study in the signed-in user's workspace. The page itself is shared with the Admin
 * route (`/admin/studies/$id`); see `features/studies/StudyPage.tsx`.
 */

import { createFileRoute } from "@tanstack/react-router";
import { StudyPage } from "@/features/studies/StudyPage";
import { validateStudySearch } from "@/features/studies/studySearch";
import { ensureStudy } from "@/features/studies/stage";
import { StudySurfaceProvider } from "@/features/studies/studySurface";

function WorkspaceStudy() {
  const { id } = Route.useParams();
  const { tab, step } = Route.useSearch();
  return (
    <StudySurfaceProvider value="workspace">
      <StudyPage id={id} tab={tab} step={step} />
    </StudySurfaceProvider>
  );
}

export const Route = createFileRoute("/_auth/_agents/studies/$id/")({
  // The active tab lives in the URL (?tab=) so it's bookmarkable. Retired act-as params from old
  // bookmarks are not study state: the `_agents` layout strips (or, for staff, re-homes) them.
  validateSearch: validateStudySearch,
  beforeLoad: ({ context, params, preload }) =>
    ensureStudy(context.queryClient, params.id, preload),
  component: WorkspaceStudy,
});
